import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { routes } from "../../../../../../redux/route-management/routes/action";
import { selectRoutesListItems } from "../../../../../../redux/route-management/routes/selector";

const TransporterRoutess = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const orderItems = useSelector(selectRoutesListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'RouteNumber', headerName: 'Route Number', sortable: true, filter: true,isEdit: true },
          { field: 'RouteName', headerName: 'Route Name' },
          { field: 'RegionName', headerName: 'Region Name'},
      
        ]);
      }
      const fetchRoutes=()=>{
        dispatch(routes.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/route-management/routes/list`,entity:'routes',jsonData:{
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
      }}))
      } 
	useEffect(() => {
        createColumnDefs()
        fetchRoutes()
		
	}, [pageData])

	return (
   
		<Table columnData={columnDefs} rowData={orderItems?.result?.items} setPageData={setPageData}
    paginationData={orderItems?.result?.pagination}  headingName="Routes" />
     
	);
};

export default TransporterRoutess;


